var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_2420)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.737 13.464a7.575 7.575 0 01-2.935-.291v7.306l.019.005a1 1 0 001.225-.708l1.691-6.312zm-8.195-8.261H4.27a1 1 0 00-1 1V21a1 1 0 001 1h9.548a1 1 0 001-1v-8.207a7.5 7.5 0 01-1.5-.934V20.5H4.77V6.703h5.763a7.6 7.6 0 01.009-1.5zm.187-1.05c.198-.78.517-1.511.938-2.172l-.721-.194a1 1 0 00-1.225.708l-.444 1.658h1.452zm-1.684 6.3s.5.51 1.283 1.333h-.001c.412.434 1.342 1.512 1.342 2.584 0 .715-.551 1.294-1.23 1.294-.446 0-.836-.25-1.05-.623a.127.127 0 00-.097-.051c-.063 0-.121.047-.114.105.047.385.254 1.335 1.066 1.656h-2.4c.813-.32 1.02-1.27 1.067-1.656.007-.058-.05-.105-.114-.105a.127.127 0 00-.097.05 1.216 1.216 0 01-1.05.624c-.68 0-1.23-.58-1.23-1.294 0-1.072.929-2.15 1.342-2.584.782-.823 1.283-1.334 1.283-1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM24 6a6 6 0 11-12 0 6 6 0 0112 0zm-6.457 1.085h.954l.135-4.01h-1.225l.136 4.01zm.942.8a.637.637 0 00-.465-.171.637.637 0 00-.466.174.58.58 0 00-.174.434c0 .175.058.32.174.433.12.114.275.171.466.171a.637.637 0 00.465-.171.573.573 0 00.178-.433.578.578 0 00-.178-.438z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_2420"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgPokerLimit.displayName = 'PokerLimit';
export default SvgPokerLimit;